import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthService } from '@wayout-admin/util';
import { Observable, first, switchMap } from 'rxjs';

export function tokenInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
	const authService = inject(AuthService);
	return authService.userToken$.pipe(
		first(),
		switchMap((token) => {
			if (token) {
				const cloned = req.clone({
					setHeaders: {
						Authorization: `Bearer ${token}`,
					},
				});
				return next(cloned);
			}
			return next(req);
		})
	);
}
